/**
 * Rutas que no son una pantalla del ERP: el login, el logout, la redirección inicial y las pantallas
 * de error o de acceso denegado. Ninguna es un sitio al que **volver** ni una pastilla que pintar en el
 * carril de contexto. Una sola lista para las dos preguntas, para que no se desincronicen.
 */
export const RUTAS_SIN_PANTALLA = ['/login', '/logout', '/error', '/acceso-denegado'];

/** Ruta de una URL: sin query ni fragmento. */
export function rutaDeUrl(url: string): string {
  return (url ?? '').split('?')[0].split('#')[0];
}

/** True si la URL es una de las rutas sin pantalla (o cuelga de ella). */
export function esRutaSinPantalla(url: string): boolean {
  const ruta = rutaDeUrl(url);
  return RUTAS_SIN_PANTALLA.some((r) => ruta === r || ruta.startsWith(`${r}/`));
}
